export default class {
    constructor (lodash, $translate, FormSubmissionResource) {
        this.lodash = lodash;
        this.$translate = $translate;
        this.FormSubmissionResource = FormSubmissionResource;
    }

    getQuizTitle (submission) {
        return this.lodash.get(
            submission,
            'trainingActiveI18n.name',
            this.$translate.instant('form.Test form')
        );
    }

    getAnswers (formSubmission) {
        const params = {
            pageSize: 0,
            guid: formSubmission.guid,
            'formIds[]': formSubmission.formId
        };
        return this.FormSubmissionResource.submittedAnswers(params).$promise;
    }

    /**
     * Keeps a single answer per question in the collection and returns the index of that answer.
     * Re-rendering a question (language switch, reloaded question list) must not leave a second
     * answer behind for the same question, the API rejects those with "Invalid questions submitted".
     *
     * @param answers
     * @param answer
     * @returns {number}
     */
    registerAnswer (answers, answer) {
        const index = this.lodash.findIndex(answers, { questionId: answer.questionId });

        if (index === -1) {
            return answers.push(answer) - 1;
        }

        answers[index] = answer;

        return index;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/form/submission/index.js